"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportModalContent = exports.NonSubmittableCategory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const CheckIcon_1 = require("../../../icons/CheckIcon");
const constants_1 = require("../../../icons/constants");
const LeftChevronIcon_1 = require("../../../icons/LeftChevronIcon");
const ReportModal_module_css_1 = __importDefault(require("../ReportModal/ReportModal.module.css"));
const constants_2 = require("./constants");
/**
 * Some top level categories are not submittable on their own and instead have
 * submittable sub categories. This enum identifies those non submittable
 * categories.
 */
var NonSubmittableCategory;
(function (NonSubmittableCategory) {
    NonSubmittableCategory[NonSubmittableCategory["HARASSMENT"] = 0] = "HARASSMENT";
    NonSubmittableCategory[NonSubmittableCategory["HURT"] = 1] = "HURT";
    NonSubmittableCategory[NonSubmittableCategory["JUST_DONT_LIKE"] = 2] = "JUST_DONT_LIKE";
    NonSubmittableCategory[NonSubmittableCategory["NUDITY"] = 3] = "NUDITY";
    NonSubmittableCategory[NonSubmittableCategory["IMPERSONATION"] = 4] = "IMPERSONATION";
    NonSubmittableCategory[NonSubmittableCategory["COPYRIGHT"] = 5] = "COPYRIGHT";
    NonSubmittableCategory[NonSubmittableCategory["THREAT"] = 6] = "THREAT";
    NonSubmittableCategory[NonSubmittableCategory["MORE_OPTIONS"] = 7] = "MORE_OPTIONS";
})(NonSubmittableCategory = exports.NonSubmittableCategory || (exports.NonSubmittableCategory = {}));
function ReportCategoryButton({ text, ...props }) {
    return ((0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: web_sds_c_1.ButtonColor.BLACK, ...props, children: (0, jsx_runtime_1.jsx)("span", { className: ReportModal_module_css_1.default.reportCategory, children: text }) }));
}
function createReportCategoryButton(key, category, selected, onClick) {
    return ((0, jsx_runtime_1.jsx)("div", { className: ReportModal_module_css_1.default.reportCategoryWrapper, children: (0, jsx_runtime_1.jsx)(ReportCategoryButton, { ...category, 
            /* eslint-disable-next-line react/jsx-no-bind */
            onClick: onClick, icon: selected ? (0, jsx_runtime_1.jsx)(CheckIcon_1.CheckIcon, { size: "SMALL" }) : undefined }) }, key));
}
function BackReportCategoryButton({ onClick }) {
    return ((0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: web_sds_c_1.ButtonColor.GRAY, onClick: onClick, icon: (0, jsx_runtime_1.jsx)(LeftChevronIcon_1.LeftChevronIcon, { size: constants_1.Sizes.Small }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "l8bRxV", defaultMessage: "Back", description: "Back button on the report snap modal" }) }));
}
/**
 * Report modal for player videos
 */
function ReportModalContent({ reportCategories, withBackButton, withDescriptionField, textFieldTitle, textFieldDescription, selectedReason: selectedCategory, onCategoryClick, onReasonClick, onBackButtonClick, onReportDescriptionChange, isMobile, hasSubmitted, }) {
    const contentsContainerRef = (0, react_1.useRef)(null);
    const onTextFieldChange = (0, react_1.useCallback)((event) => {
        onReportDescriptionChange?.(event.target.value);
    }, [onReportDescriptionChange]);
    const scrollDescriptionIntoView = () => {
        if (!isMobile) {
            return;
        }
        process.nextTick(() => {
            contentsContainerRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "end",
            });
        });
    };
    const intl = (0, react_intl_1.useIntl)();
    const placeholder = intl.formatMessage({
        defaultMessage: "Please provide your Snapchat username if you have one, and the email associated with your account",
        description: "Placeholder in text box where user can provide more information",
    });
    return ((0, jsx_runtime_1.jsxs)("div", { ref: contentsContainerRef, children: [hasSubmitted && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: ReportModal_module_css_1.default.reportSubtext, children: constants_2.REPORT_SUBMITTED_MESSAGE }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { className: ReportModal_module_css_1.default.reportSubtext, children: constants_2.REPORT_SUBMITTED_CLOSE_MESSAGE })] })), !hasSubmitted && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: ReportModal_module_css_1.default.reportSubtext, children: constants_2.REPORT_SUBTEXT }), (0, jsx_runtime_1.jsxs)("div", { className: ReportModal_module_css_1.default.reportCategoriesContainer, children: [withBackButton && ((0, jsx_runtime_1.jsx)("div", { className: ReportModal_module_css_1.default.backButton, children: (0, jsx_runtime_1.jsx)(BackReportCategoryButton, { onClick: onBackButtonClick }) })), !reportCategories &&
                                [...constants_2.DEFAULT_CATEGORIES].map(([id, category], index) => 
                                // @ts-ignore
                                createReportCategoryButton(index, category, selectedCategory === id, () => {
                                    onCategoryClick(id);
                                    // Scroll to the description field after selecting category ( useful for small screens ).
                                    scrollDescriptionIntoView();
                                })), reportCategories &&
                                [...reportCategories].map(([id, category]) => 
                                // @ts-ignore
                                createReportCategoryButton(id, category, selectedCategory === id, () => {
                                    onReasonClick(id);
                                    scrollDescriptionIntoView();
                                }))] }), withDescriptionField && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: ReportModal_module_css_1.default.reportTextFieldTitle, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H6", children: textFieldTitle }) }), (0, jsx_runtime_1.jsx)("textarea", { className: ReportModal_module_css_1.default.reportTextField, placeholder: placeholder, value: textFieldDescription, onChange: onTextFieldChange })] }))] }))] }));
}
exports.ReportModalContent = ReportModalContent;
//# sourceMappingURL=ReportModalContent.js.map